import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const addCity = createAsyncThunk('city/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/city/create-city`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editCity = createAsyncThunk('city/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/city/update-city/${data?.city_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteCity = createAsyncThunk('city/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/admin/city/delete-city/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllCity = createAsyncThunk('city/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/city/get-all-city`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCityByID = createAsyncThunk('city/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/city/get-city/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCityByRegion = createAsyncThunk('city/getByRegion', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/city/get-city-by-region/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCityByCityName = createAsyncThunk('city/get-city-by-city-name', async (city, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/city/get-city-by-city-name?city=${city}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allCity: [],
  allCityByRegion: [],
  getCity: null,
  city: null,
  error: null
}

const citySlice = createSlice({
  name: 'city',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.user = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCity.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addCity.fulfilled, (state, action) => {
        state.isLoading = false
        state.city = action.payload?.data?.data
      })
      .addCase(addCity.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editCity.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editCity.fulfilled, (state, action) => {
        state.isLoading = false
        state.city = action.payload?.data?.data
      })
      .addCase(editCity.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteCity.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteCity.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteCity.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllCity.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllCity.fulfilled, (state, action) => {
        state.isLoading = false
        state.allCity = action.payload?.data?.data
      })
      .addCase(getAllCity.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getCityByID.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCityByID.fulfilled, (state, action) => {
        state.isLoading = false
        state.getCity = action.payload?.data?.data
      })
      .addCase(getCityByID.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getCityByRegion.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCityByRegion.fulfilled, (state, action) => {
        state.isLoading = false
        state.allCityByRegion = action.payload?.data?.data
      })
      .addCase(getCityByRegion.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.allCityByRegion = []
      })
      .addCase(getCityByCityName.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCityByCityName.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(getCityByCityName.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = citySlice.actions
export default citySlice.reducer
